export default function currencyXAF (value) {
  if (typeof value !== 'number') return value
  // Format as XAF with no decimals, with thousands separator
  return value.toLocaleString('en-US', { style: 'currency', currency: 'XAF', minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace('XAF', 'XAF')
}
